(function () {
  'use strict';
  var KEY = 'mtPendingFollowV4';
  var generation = 0;
  var active = null;
  var waiting = null;
  try { localStorage.removeItem('mtPendingFollow'); localStorage.removeItem('mtReturnTo'); } catch (e) {}

  function forget() {
    try { sessionStorage.removeItem(KEY); } catch (e) {}
  }

  function remember(pending) {
    try { sessionStorage.setItem(KEY, JSON.stringify(pending)); return true; } catch (e) { return false; }
  }

  function show(account, message) {
    var parent = account.closest('.mt-follow-auth-panel') || account.closest('.mtf-wrap');
    var status = parent && parent.querySelector('.mt-follow-auth-result');
    if (status) status.textContent = message || '';
  }

  function invalidate() {
    generation += 1;
    active = null;
    waiting = null;
    forget();
  }

  function sessionReady(doc, wrap) {
    if (wrap) {
      var fresh = doc.getElementById(wrap.id);
      return !!(fresh && fresh.getAttribute('data-auth'));
    }
    var following = doc.querySelector('.mtf-wrap');
    return !!(following && following.getAttribute('data-minty-signed-in') === 'true');
  }

  async function probe(context, epoch, attempt) {
    if (epoch !== generation || context.probing) return;
    if (Date.now() - context.closedAt >= 5000) { invalidate(); show(context.account, context.account.dataset.messageClosed); return; }
    context.probing = true;
    var ready = false;
    try {
      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, Math.min(2500, 5000 - (Date.now() - context.closedAt)));
      try {
        var response = await fetch(location.href, { credentials:'same-origin', cache:'no-store', signal:controller.signal });
        if (response.ok) {
          var html = await response.text();
          ready = sessionReady(new DOMParser().parseFromString(html, 'text/html'), context.wrap);
        }
      } finally { window.clearTimeout(timeout); }
    } catch (e) {}
    context.probing = false;
    if (epoch !== generation) return;
    if (ready) {
      if (context.pending) remember(context.pending);
      show(context.account, context.account.dataset.messageRefresh);
      waiting = null;
      location.reload();
      return;
    }
    var delays = [250, 600, 1200];
    if (attempt < delays.length && Date.now() - context.closedAt < 5000) {
      window.setTimeout(function () { probe(context, epoch, attempt + 1); }, delays[attempt]);
    } else {
      invalidate();
      show(context.account, context.account.dataset.messageClosed);
    }
  }

  function bind(account) {
    if (account.dataset.mintyAuthBound === '1') return;
    account.dataset.mintyAuthBound = '1';
    account.addEventListener('open', function () {
      invalidate();
      if (!account.hasAttribute('data-minty-account')) return;
      var wrap = account.closest('.mt-follow');
      var pending = wrap ? {
        type:wrap.getAttribute('data-follow-type'), value:wrap.getAttribute('data-follow-value'),
        label:wrap.getAttribute('data-follow-label'),
        returnTo:location.pathname + location.search + location.hash, createdAt:Date.now()
      } : null;
      active = { account:account, wrap:wrap, pending:pending };
      if (pending && !remember(pending)) show(account, account.dataset.messageStorage);
      else show(account, '');
    });
    account.addEventListener('close', function () {
      if (!active || active.account !== account) return;
      var context = active;
      active = null;
      forget();
      context.closedAt = Date.now();
      waiting = context;
      show(account, account.dataset.messageChecking);
      probe(context, generation, 0);
    });
  }

  function init() {
    document.querySelectorAll('shopify-account').forEach(bind);
    document.querySelectorAll('[data-follow-auth]').forEach(function (details) {
      var account = details.querySelector('[data-minty-account]');
      var cancel = details.querySelector('.mt-follow-auth-cancel');
      var summary = details.querySelector('summary');
      function cancelIntent() {
        invalidate();
        if (account) show(account, '');
      }
      details.addEventListener('toggle', function () { if (!details.open) cancelIntent(); });
      if (cancel) cancel.addEventListener('click', function () { cancelIntent(); details.open = false; summary.focus(); });
      details.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && details.open && !active) {
          cancelIntent(); details.open = false; summary.focus(); event.preventDefault();
        }
      });
    });
    window.addEventListener('pagehide', function () { if (waiting) invalidate(); });
    window.addEventListener('focus', function () {
      if (waiting && Date.now() - waiting.closedAt < 5000) probe(waiting, generation, 3);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();
